const DefaultConfig = { // 6x fromat
  appenders: {
    out: { type: 'console' }
  },
  categories: {
    default: { appenders: ['out'], level: 'error' }
  }
}

export default DefaultConfig

export { DefaultConfig }
